import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  FaSearch, 
  FaNewspaper, 
  FaCheckCircle, 
  FaArrowRight 
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../axios/api";

const NoticiasCatalogo = () => {
  const [noticias, setNoticias] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    let isMounted = true;
    const fetchNoticias = async () => {
      try {
        const res = await api.get("/noticias");
        const dadosNoticias = Array.isArray(res.data) ? res.data : (res.data.data || []);
        
        if (isMounted) {
          setNoticias(dadosNoticias);
        }
      } catch (error) {
        console.error("Erro ao carregar notícias:", error);
      }
    };

    fetchNoticias();
    return () => { isMounted = false; };
  }, []);

  // Omitir se status === 0 e aplicar filtro por título ou descrição
  const noticiasFiltradas = noticias.filter(noticia => {
    if (noticia.status === 0 || noticia.status === "0" || noticia.status === false) {
      return false;
    }

    const termo = searchTerm.toLowerCase();
    const titulo = (noticia.titulo || "").toLowerCase();
    const descricao = (noticia.descricao || "").toLowerCase();

    return titulo.includes(termo) || descricao.includes(termo);
  });

  return (
    <main className="bg-white text-dark">
      <Header />

      {/* Hero Section */}
      <section className="bg-black text-white py-5 position-relative overflow-hidden">
        <div className="container py-4 text-center position-relative z-2">
          <span className="text-warning fw-bold text-uppercase tracking-wider small mb-2 d-block">
            Início / Notícias
          </span>
          <h1 className="display-4 fw-bold mb-3">
            Notícias & <span className="text-warning">Artigos</span>
          </h1>
          <p className="lead text-light opacity-75 mx-auto mb-4" style={{ maxWidth: '700px' }}>
            Acompanhe as últimas novidades, tendências e atualizações da nossa instituição.
          </p>
        </div>
      </section>

      {/* Search Bar */}
      <section className="py-4 bg-light border-bottom">
        <div className="container">
          <div className="row g-3 align-items-center">
            <div className="col-lg-12">
              <div className="input-group">
                <span className="input-group-text bg-white border-end-0 text-muted"><FaSearch /></span>
                <input 
                  type="text" 
                  className="form-control border-start-0 shadow-none" 
                  placeholder="Pesquisar por título ou descrição da notícia..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Area */}
      <section className="py-5">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <span className="text-muted small">Mostrando notícias publicadas</span>
            <span className="badge bg-dark text-warning p-2">Total: {noticiasFiltradas.length} notícias</span>
          </div>

          <div className="row g-4">
            {noticiasFiltradas.length > 0 ? (
              noticiasFiltradas.map((noticia, index) => (
                <div key={noticia.id || index} className="col-md-6 col-lg-4">
                  <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden bg-light">
                    {noticia.foto && (
                      <Link to={`/noticias/${noticia.id}`} style={{ height: '200px', overflow: 'hidden' }} className="bg-secondary position-relative d-block">
                        <img 
                          src={noticia.foto} 
                          alt={noticia.titulo || "Notícia"} 
                          className="w-100 h-100 object-fit-cover"
                        />
                      </Link>
                    )}
                    <div className="card-body p-4 d-flex flex-column">
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <FaNewspaper className="text-warning" />
                        <h5 className="fw-bold mb-0 text-dark">
                          <Link to={`/noticias/${noticia.id}`} className="text-dark text-decoration-none">
                            {noticia.titulo || "Notícia sem título"}
                          </Link>
                        </h5>
                      </div>
                      <p className="text-muted small mb-4 flex-grow-1">
                        {noticia.descricao || "Sem descrição informada para esta notícia."}
                      </p>
                      
                      <div className="d-flex align-items-center justify-content-between pt-3 border-top mt-auto">
                        <span className="badge bg-success text-white px-2 py-1 small d-flex align-items-center gap-1">
                          <FaCheckCircle size={10} /> Publicado
                        </span>
                        
                        <Link to={`/noticias/${noticia.id}`} className="btn btn-sm btn-dark text-warning d-flex align-items-center gap-1">
                          Ler mais <FaArrowRight size={10} />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center py-5 bg-light rounded-4 border">
                <h5 className="text-dark fw-bold mb-2">Nenhuma notícia encontrada</h5>
                <p className="text-muted small mb-0">Não há notícias ativas correspondentes à sua pesquisa.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default NoticiasCatalogo;